import Transformer from './transformer';

export default class providerTypeDetailTransformer extends Transformer {
  static fetch(data) {
    return {
      id: data.id,
      name_en: this.getLangName(data.name, 'en'),
      name_th: this.getLangName(data.name, 'th'),
      description_en: this.getLangName(data.description, 'en'),
      description_th: this.getLangName(data.description, 'th'),
      created_at: data.created_at,
      updated_at: data.updated_at,
    };
  }

  static getLangName(name, lang) {
    const nameObject = JSON.parse(name);

    return lang === 'en' ? nameObject.en : nameObject.th;
  }
}
